<template>
    <div class="container">
        <br><br><br>
        <h3>Website Terms and Conditions</h3>
        <p>When someone visits <strong><a class="link" href="http://www.drandrewsoffice.co.uk">www.drandrewsoffice.co.uk</a></strong> we use a third party service, Google Analytics, to collect standard internet log information and details of visitor behaviour patterns. We do this to find out things such as the number of visitors to the various parts of the site. This information is only processed in a way which does not identify anyone. We do not make, and do not allow Google to make, any attempt to find out the identities of those visiting our website.</p>
        <br>
        <p>You can set your browser not to accept cookies and the above websites tell you how to remove cookies from your browser.&nbsp; However, in a few cases some of our website features may not function as a result.</p>
        <br>
        <p>For further information, visit <a class="link" href="http://www.aboutcookies.org/">www.aboutcookies.org</a> or <a class="link" href="http://www.allaboutcookies.org/">www.allaboutcookies.org</a>.</p>
        <br>
        <p><strong>Links to other websites</strong></p>
        <p><br /> Our website contains links to other websites.&nbsp; This privacy policy only applies to this website so when you link to other websites you should read their own privacy policies.</p>
        <br>
        <p><strong>DISCLAIMER</strong></p>
        <p>While we endeavour to ensure that the information on this Website is correct, we do not warrant that it is accurate, complete or up to date. We may make changes to the material on this Website, or to the Products described in it, at any time without notice.</p>
        <p>Any data contained on the Website is provided for guidance only and is not intended to be definitive. To the maximum extent permitted by law, we provide you with this Website on the basis that we exclude all representations, warranties, conditions and other terms which but for these Terms might have effect in relation to this Website. You must bear the risks associated with the use of the Internet. This clause does not affect your statutory rights.</p>
    </div>
</template>

<script>
export default {
  name: 'WebsiteTermsAndConditions'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/WebsiteTermsAndConditions.vue